import { render, staticRenderFns } from "./ClientRights.vue?vue&type=template&id=69cb755a"
import script from "./ClientRights.vue?vue&type=script&lang=js"
export * from "./ClientRights.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports